import { Container } from 'src/components/common/Container'
import React, { useEffect } from 'react'
import { CouponMapProps } from 'src/pages/CouponMapPage'
import useDynamicHeight from 'src/hooks/useDynamicHeight.hook'
import styled from 'styled-components'
import { layoutMaxSize, ZIndex } from 'src/styles/mixin'

import BrandMenuBottomSheetHeader from 'src/pages/CouponMapPage/_components/BrandMenuBottomSheet/BrandMenuBottomSheetHeader'
import BrandMenuBottomSheetBody from 'src/pages/CouponMapPage/_components/BrandMenuBottomSheet/BrandMenuBottomSheetBody'
import { motion } from 'framer-motion'
import BackGroundDeem from 'src/components/common/BackgroundDeem'
import RenderIf from 'src/components/common/RenderIf'

const BrandMenuBottomSheet = (props: CouponMapProps) => {
  const { bottomSheetControl, handleBottomSheetAnimation, bottomSheetToggle } = props
  const { deviceHeight } = useDynamicHeight()

  useEffect(() => {
    bottomSheetToggle ? handleBottomSheetAnimation.open() : handleBottomSheetAnimation.close()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bottomSheetToggle])

  return (
    <React.Fragment>
      <RenderIf when={bottomSheetToggle}>
        <BackGroundDeem />
      </RenderIf>
      <S.CouponMapBrandFilterContainer
        as={motion.div}
        $option="flex_column"
        $deviceHeight={deviceHeight}
        animate={bottomSheetControl}
        initial={handleBottomSheetAnimation.initial}
      >
        <S.CouponMapBrandFilterInner $option="flex_column">
          <BrandMenuBottomSheetHeader {...props} />
          <BrandMenuBottomSheetBody {...props} />
        </S.CouponMapBrandFilterInner>
      </S.CouponMapBrandFilterContainer>
    </React.Fragment>
  )
}
export default BrandMenuBottomSheet

const S = {
  CouponMapBrandFilterContainer: styled(Container)<{ $deviceHeight: number }>`
    position: fixed;
    left: 0;
    right: 0;
    justify-content: center;
    bottom: 0;
    margin: auto;
    padding: 10px 0;
    z-index: ${ZIndex.BottomSheet};
    border-radius: 30px 30px 0 0;
    background: var(--white);
    ${layoutMaxSize};
    height: ${(props) => `${props.$deviceHeight * 0.67}px`};
  `,
  CouponMapBrandFilterInner: styled(Container)`
    flex: 1;
    overflow-y: scroll;
    &::-webkit-scrollbar,
    &::-webkit-scrollbar-thumb {
      display: none;
    }
  `,
}
